/** Shared expanded width for collection listings and activity rails. */
export const COLLECTION_RAIL_WIDTH = 'clamp(300px, 19vw, 340px)'
